module.exports = __webpack_public_path__ + "img/benefit-07-trace-1.9c6cbd6d.png";